import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  UpdateCompanySignature,
  UpdateIndividualSignature,
  UpdatePersonalSignature,
  getCompanySignature,
  getIndividualSignature,
  getPersonalSignature,
} from "controller/api";
import { ApiErrorType } from "shared";
import { sentryLogger } from "utilz";

export const useGetCompanySignature = () => {
  return useQuery({
    queryKey: ["company-signature"],
    queryFn: getCompanySignature,
    onError: (error: ApiErrorType) =>
      sentryLogger({
        error: error,
        workflow: "controlCenter",
        level: "error",
        functionName: "getCompanySignature",
      }),
  });
};

export const useGetIndividualSignature = () => {
  return useQuery({
    queryKey: ["individual-signature"],
    queryFn: getIndividualSignature,
    onError: (error: ApiErrorType) =>
      sentryLogger({
        error: error,
        workflow: "controlCenter",
        level: "error",
        functionName: "getIndividualSignature",
      }),
  });
};

export const useUpdateCompanySignature = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: UpdateCompanySignature,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["company-signature"] });
    },
    onError: (error: ApiErrorType) =>
      sentryLogger({
        error: error,
        workflow: "controlCenter",
        level: "error",
        functionName: "UpdateCompanySignature",
      }),
  });
};

export const useUpdateIndividualSignature = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: UpdateIndividualSignature,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["individual-signature"] });
    },
    onError: (error: ApiErrorType) =>
      sentryLogger({
        error: error,
        workflow: "controlCenter",
        level: "error",
        functionName: "UpdateIndividualSignature",
      }),
  });
};


export const useGetPersonalSignature = () => {
  return useQuery({
    queryKey: ["personal-signature"],
    queryFn: getPersonalSignature,
    onError: (error: ApiErrorType) =>
      sentryLogger({
        error: error,
        workflow: "controlCenter",
        level: "error",
        functionName: "getPersonalSignature",
      }),
  });
};

export const useUpdatePersonalSignature = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: UpdatePersonalSignature,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["personal-signature"] });
    },
    onError: (error: ApiErrorType) =>
      sentryLogger({
        error: error,
        workflow: "controlCenter",
        level: "error",
        functionName: "UpdatePersonalSignature",
      }),
  });
};

